import fetch from "isomorphic-fetch";
import webuiState from "../../app/InternalStateService";
import normalizeUrlSlashes from "@tinqin/tinqin-utils/src/url/normalizeUrlSlashes";

//adjusts endpoint and headers then executes the request
export const executeRequest = (action, state) => {
    let sameOrigin =
        typeof action.options.sameOrigin !== "undefined" ? action.options.sameOrigin : true;
    let options = {
        headers: action.options.headers || {},
        credentials: "include",
        sameOrigin: sameOrigin,
        rawEndpointUrl: !!action.options.rawEndpointUrl,
        contextPath: action.options.contextPath
    };
    let endpoint = getEndpoint(action.options.endpoint, options, state);
    let externalApi = endpoint.match(/^https?:/);

    options.headers["Content-Language"] = state.getIn(["global", "locale"]);
    if (action.options.method) {
        let method = action.options.method;
        if (method === "PUT") {
            options = Object.assign({}, options, {
                method: "POST",
                "X-HTTP-Method-Override": "PUT"
            });
        } else {
            options = Object.assign({}, options, { method: method });
        }
    }

    if (action.payload) {
        if (isFormData(action.options)) {
            // remove Content-Type in case of wrongly provided
            if (options.headers && options.headers["Content-Type"]) {
                delete options.headers["Content-Type"];
            }
            options = Object.assign({}, options, { body: action.payload });
        } else {
            options = Object.assign({}, options, { body: JSON.stringify(action.payload) });
        }
    }

    //JWT support :P
    let tokenId = null;
    if (state.toJS) {
        tokenId = state.getIn(["login", "tokenId"]);
    } else {
        tokenId = state.login && state.login.tokenId ? state.login.tokenId : null;
    }
    if (tokenId) {
        options.headers.authorization = `Bearer ${tokenId}`;
    }

    //add no-cache control for all requests
    //issue with IE request caching
    let requestHeaders = Object.assign(
        {
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        },
        options.headers
    );

    let requestOptions = Object.assign({}, options, {
        headers: requestHeaders
    });

    // external api can't be with sameOrigin and for cases used by now,
    // we don't want to have any headers. (may be changed in future)
    //case when the api root is provided by a config file with api path
    let { API_ROOT } = webuiState.getWebConfig();
    if (externalApi && !endpoint.includes(API_ROOT)) {
        delete requestOptions.sameOrigin;
        delete requestOptions.credentials;
        requestOptions.headers = {};
    }

    return fetch(endpoint, requestOptions).then(response => {
        //fetch returns resolved Promise on all responses except network fails
        //Reference: https://github.com/github/fetch#caveats
        if (response.ok) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    });
};

function isFormData(action) {
    let headers = action.headers || {};
    let contentType = headers["Content-Type"] || "";
    return contentType.includes("multipart/form-data");
}

function getEndpoint(inputEndpoint, options, state) {
    let endpoint = inputEndpoint;
    if (typeof endpoint === "function") {
        endpoint = endpoint(state);
    }

    if (typeof endpoint !== "string") {
        throw new Error("Specify a string endpoint URL.");
    }
    let { API_ROOT, ROOT_PATH } = webuiState.getWebConfig();

    let externalApi = endpoint.match(/^https?:/);
    // if the endpoint stats with http(s), we don't want to add ROOT_PATH or API_ROOT
    if (externalApi) {
        return endpoint;
    }
    // external address
    if (!options.sameOrigin) {
        return endpoint;
    }
    //no web config declaration about the root path
    if (!API_ROOT) {
        return endpoint;
    }
    //context path
    if (options.contextPath) {
        return `${options.contextPath}${endpoint}`;
    }

    if (!endpoint.includes(API_ROOT)) {
        if (endpoint.startsWith(webuiState.getGlobalProperties("staticApiPublicPath"))) {
            endpoint = ROOT_PATH + endpoint;
            //TODO to deprecate?
        } else if (endpoint[0] === "!") {
            // added in case that BE don't listen on /api/ - used with static configurations
            endpoint = ROOT_PATH + endpoint.substr(1);
        } else if (options.rawEndpointUrl) {
            endpoint = normalizeUrlSlashes(ROOT_PATH + endpoint); //removing double slashes.
        } else {
            endpoint = API_ROOT + endpoint;
        }
    }
    return endpoint;
}
